import { useMemo, useState } from 'react';
import { Select } from 'antd';
import type { SelectProps } from 'antd';
import { formatStock } from '@app/shared';
import { useSearchCategoriesQuery } from '../api/categoryApi';
import type { CategoryDto } from '../model/types';

export interface CategorySearchSelectProps {
  value?: string;
  onChange: (id: string, category: CategoryDto) => void;
  autoFocus?: boolean;
  disabled?: boolean;
  onKeyDown?: SelectProps['onKeyDown'];
}

/** §5: «в списке виден остаток» — категория + К/Р справа. */
export function CategorySearchSelect({ value, onChange, autoFocus, disabled, onKeyDown }: CategorySearchSelectProps) {
  const [q, setQ] = useState('');
  const { data = [], isFetching } = useSearchCategoriesQuery({ q: q || undefined, limit: 30 });

  const options = useMemo(
    () =>
      data.map((c) => ({
        value: c.id,
        label: (
          <span style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
            <span>{c.name}</span>
            {c.stock ? <span style={{ color: '#8c8c8c' }}>{formatStock(c.stock)}</span> : null}
          </span>
        ),
        category: c,
      })),
    [data],
  );

  return (
    <Select
      value={value}
      showSearch
      filterOption={false}
      autoFocus={autoFocus}
      disabled={disabled}
      loading={isFetching}
      placeholder="Товар"
      style={{ width: '100%', minWidth: 200 }}
      onSearch={setQ}
      onKeyDown={onKeyDown}
      onChange={(id: string) => {
        const found = data.find((c) => c.id === id);
        if (found) onChange(id, found);
      }}
      options={options}
    />
  );
}
